import React, { Component } from 'react'
import spinkit from 'spinkit/scss/spinners/11-folding-cube.scss'
import classes from './Loader.scss'

class LoadingOverlay extends Component {
  render () {
    return (
      <div className='overlay' style={{ display: this.props.hidden ? 'none' : 'table' }}>
        <div className='overlay-cell'>
          <div className={spinkit['sk-folding-cube']}>
            <div className={`${spinkit['sk-cube1']} ${spinkit['sk-cube']} ${classes.loadingColor}`} />
            <div className={`${spinkit['sk-cube2']} ${spinkit['sk-cube']} ${classes.loadingColor}`} />
            <div className={`${spinkit['sk-cube4']} ${spinkit['sk-cube']} ${classes.loadingColor}`} />
            <div className={`${spinkit['sk-cube3']} ${spinkit['sk-cube']} ${classes.loadingColor}`} />
          </div>
        </div>
      </div>
    )
  }
}

export default LoadingOverlay



/** WEBPACK FOOTER **
 ** ./src/components/LoadingOverlay.js
 **/